import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Collapse } from "reactstrap";
import withSizes from "react-sizes";

import NavMenu from "./NavMenu";

import logo from "../assets/images/staygolf_logo.svg";
import iconBars from "../assets/images/icon-bars.svg";
import iconClose from "../assets/images/icon-bar-close.svg";
// import iconClose from "../assets/images/icon-close.svg";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.handleToggleMenu = this.handleToggleMenu.bind(this);
  }
  handleToggleMenu() {
    this.setState((state) => ({
      isOpen: !state.isOpen,
    }));
  }

  // state = {
  //   isOpen: false
  // };

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };
  render() {
    return (
      <header className="siteheader clearfix">
        <div className="container">
          <div className="masthead">
            <Link to="/" className="main_logo">
              <img alt="Staysure" src={logo} />
            </Link>
            <div className="mobile-menu" />
            <button
              className="jstoggle jstoggle--nav__list"
              data-toggle="nav__list"
              onClick={this.toggle}
            >
              {this.state.isOpen ? (
                <img src={iconClose} alt="icon-bars" />
              ) : (
                <img src={iconBars} alt="icon-bars" />
              )}
            </button>

            <div className="header_get_quote border-left-0 mr-0 ml-0 ml-md-auto">
              <span>Be covered in minutes</span>
              <div className="btn-group">
                {/* <Link to="/products" className="btn-get-quote">
                  <i className="fa fa-caret-right" /> Get Golf Insurance
                </Link> */}
                <a
                  href={process.env.REACT_APP_STAYSURE_URL}
                  className="btn-get-quote"
                >
                  <i className="fa fa-caret-right" /> Get Travel Insurance
                </a>
              </div>
            </div>
          </div>
          {/* style={{ display: this.props.isDesktop ? "show" : "hide" }} */}
          <Collapse isOpen={this.state.isOpen} navbar>
            <div style={{ display: this.props.isDesktop ? "none" : "block" }}>
              <NavMenu
                isOpen={this.state.isOpen}
                onToggleMenu={this.handleToggleMenu}
              />
            </div>
          </Collapse>
          <div style={{ display: this.props.isDesktop ? "block" : "none" }}>
            <NavMenu />
          </div>
        </div>
      </header>
    );
  }
}

const mapSizesToProps = ({ width }) => ({
  isDesktop: width > 764,
});

export default withSizes(mapSizesToProps)(Header);
